import { isAdmin } from "~/common/helper/validator"

export default function ({ redirect, $auth }) {
    const admin = isAdmin($auth.user)
  
    if (!admin) {
      return redirect({ path: '/wedding' })
    }
}
  